import api from "@app/config/api/api";

export const useSearch = (query: string) =>
  api.useQuery("get", "/search/", { params: { query: { query } } }, { enabled: query.trim().length > 0 });
